export const TITLE = "OSM Electric Auto Price in India 2026 | OSM Auto Rickshaw";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "OSM Electric Auto price in India ranges from ₹3.6 - ₹8.4 Lakh. Explore OSM commercial vehicles, range, images, features & on-road prices.",
  },
  {
    name: "keywords",
    content:
      "OSM electric auto, OSM 3 wheeler, OSM electric vehicles, OSM three wheeler, OSM electric auto price, OSM commercial vehicles, OSM EV auto, OSM electric truck, OSM Auto Rickshaw, OSM Rage+, OSM Rage+ Frost, OSM price in India, OSM dealers, OSM specifications, OSM features, OSM battery capacity, OSM range, OSM charging, OSM EMI, OSM financing, OSM test drive, OSM Auto Rickshaw",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/OSM",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/OSM",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "OSM Electric Auto Price in India 2026 | OSM Auto Rickshaw",
  },
  {
    property: "og:description",
    content:
      "OSM Electric Auto price in India ranges from ₹3.6 - ₹8.4 Lakh. Explore OSM commercial vehicles, range, images, features & on-road prices.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "OSM Electric Auto price in India ranges from ₹3.6 - ₹8.4 Lakh. Explore OSM commercial vehicles, range, images, features & on-road prices.",
  },
  {
    name: "twitter:title",
    content: "OSM Electric Auto Price in India 2026 | OSM Auto Rickshaw",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/OSM",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/OSM";

export const H1_HEADING = "OSM Electric Auto - Revolutionising Last-Mile Logistics";

export const ATF_CONTENT = {
  text: [
    "Omega Seiki Mobility (OSM) is rapidly becoming a dominant force in the Indian clean energy transportation sector. The brand is offering a versatile range of OSM electric autos designed for both passenger and heavy-duty last-mile logistics. With the flagship OSM Rage Plus leading the charge, the brand's focus is on high-torque performance and low operational costs. Whether you are looking for an OSM three wheeler for urban delivery or a passenger OSM vehicle, Omega Seiki provides a future-ready platform to scale your business.",
    "To help you choose the right OSM electric 3 wheeler for your business needs, here is a detailed comparison of the latest models available at Turno. At present, we are offering three OSM three wheelers, viz., OSM Rage Plus, OSM Rage Plus 10.8 kWh and OSM Rage Plus Frost. You can find the perfect OSM Auto price and performance balance for your business requirements.",
  ],
};

export const ATF_NOTE =
  "Note: Prices are ex-showroom and may vary. On-road price depends on RTO, insurance, and state subsidies.";

export const ATF_TABLE_HEADING = "OSM Electric Auto Price List in India 2026";

export const ATF_TABLE_COLUMNS = [
  { key: "model", label: "OSM Model Name" },
  { key: "payload", label: "Payload" },
  { key: "topSpeed", label: "Top Speed" },
  { key: "range", label: "Max Range" },
  { key: "price", label: "Price (Ex-showroom)" },
];

export const ATF_TABLE_DATA = [
  { model: "OSM Rage Plus", payload: "500 kg", topSpeed: "45 kmph", range: "120 km", price: "₹3.60 Lakh", link: "/electric-commercial-vehicles/OSM/Rage-plus" },
  { model: "OSM Rage Plus 10.8 kWh", payload: "550 kg", topSpeed: "50 kmph", range: "151 km", price: "₹4.10 Lakh", link: "/electric-commercial-vehicles/OSM/Rage-+-10.8-kwh" },
  { model: "OSM Rage Plus Frost", payload: "500 kg", topSpeed: "50 kmph", range: "80 km", price: "₹8.41 Lakh", link: "/electric-commercial-vehicles/OSM/Rage-+-Frost" },
];

export const SEO_FOOTER_CONTENT = [
  {
    heading: "About OSM Electric Mobility",
    paragraphs: [
      "Omega Seiki Mobility (OSM) is a part of the Anglian Omega Group. Hence, the brand is able to take advantage of decades of steel manufacturing excellence to build robust EVs. As a leading OSM three wheeler manufacturer, they have established a massive network with every OSM electric auto showroom near me offering end-to-end service and financing. Their focus on the \"Rage\" and \"Stream\" series has made them a household name in the OSM ev market.",
    ],
  },
  {
    heading: "OSM Battery Electric Auto USPs",
    list: [
      {
        label: "Advanced Telematics",
        text: "The brand offers real-time tracking and battery health monitoring via the OSM mobile app.",
      },
      {
        label: "Rapid Charging",
        text: "The flagship models support fast charging technology. This is helping drivers and fleet owners to cut down times and increase profitability.",
      },
      {
        label: "Thermal Management",
        text: "OSM has ensured that their batteries are designed to operate efficiently in extreme Indian temperatures (up to 50°C).",
      },
      {
        label: "High Payload",
        text: "The OSM Rage Plus offers a class-leading capacity of up to 550 kg for heavy industrial loads.",
      },
    ],
  },
  {
    heading: "OSM Electric 3 Wheeler Insights",
    list: [
      {
        label: "Cargo Specialisation",
        text: "OSM offers unique solutions like the Frost variant for pharma and cold-chain logistics.",
      },
      {
        label: "Low TCO",
        text: "Owners report saving up to ₹45,000 per year on maintenance compared to traditional OSM auto models.",
      },
      {
        label: "Swappable Options",
        text: "OSM is pioneering battery swapping in certain cities to eliminate range anxiety for fleet owners.",
      },
      {
        label: "Safety Standards",
        text: "Features include hill-hold assist and reinforced crash guards as standard in the OSM 3 wheeler range.",
      },
    ],
  },
];

export const BRAND_HEADER_INFO = "OSM Electric Auto";

export const BRAND_DESCRIPTION = "Turno invites you to embrace the future of sustainable transportation with OSM Electric Auto. Explore our range of OSM electric auto models, including the OSM Rage+ and OSM Rage+ Frost, and experience the eco-friendly and efficient mobility solutions they offer. Join us in driving towards a greener tomorrow with OSM Electric Vehicles available at Turno.";

export const PRICE_LIST_HEADER = "OSM Electric Auto Price List in India 2026";

export const PRICE_LIST_DESCRIPTION = "Discover the price range of OSM electric auto, offering sustainable and cost-effective transportation solutions for various business requirements. OSM electric trucks are designed to revolutionise the commercial transportation sector with their efficiency, reliability, and eco-friendliness. Below is a table showcasing the OSM electric truck models along with their respective price ranges.";

export const PROMISES_HEADER = "Why OSM Electric Vehicles from Turno:";

export const ADVANTAGES_HEADING = "Advantages of OSM Electric Auto";

export const ADVANTAGES_DESCRIPTION = "It is important to know about all the advantages that you can get from a new OSM Electric Autos for your business. Here we have mentioned all that your business can benefit from.";

export const HIGHLIGHTS_HEADING = "Highlights of OSM EV Auto:";

export const HIGHLIGHTS_DESCRIPTION = "OSM EV Auto is a zero-emission vehicle with a long battery life that can last up to 100 kilometres on a single charge. It features regenerative braking, which helps to conserve energy and extend the battery life. OSM EV Auto is also easy to operate and offers a comfortable ride, making it a great choice for those who are looking for an eco-friendly vehicle that won't break the bank.";

export const BLOG_HEADER = "OSM Goods Electric 3 Wheelers Blogs";

export const ABOUT_HEADING = "About OSM Electric Auto:";

export const ABOUT_DESCRIPTION = "OSM offers a wide range of electric vehicles, including three-wheelers, passenger vehicles, and commercial vehicles. The company's vehicles are designed to be both eco-friendly and affordable, and they are well-suited for use in urban and rural areas. OSM has a strong focus on innovation, and the company is constantly developing new technologies to improve the performance and efficiency of its vehicles. OSM is also committed to providing excellent customer service, and the company has a nationwide network of dealerships and service centres.";

export const MODELS_HEADER = "Electric Commercial Vehicles by OSM";

export const MODELS_DESCRIPTION = "OSM Electric EV has a range of vehicles that are designed to meet the needs of different users. Here are some of the vehicles offered by OSM Electric EV:";

export const DEALER_HEADER = "OSM EV Dealers Near Me:";

export const DEALER_DESCRIPTION = "Thanks to the expansion in the company's reach and popularity, OSM is rapidly making its presence felt across India. As more people are leaning towards OSM's high-quality mobility solutions that offer excellent value for money, Turno brings you this exceptional range of Electric Trucks at affordable prices. If you want to purchase OSM electric vehicles you can always head to Turno.";

export const FAQ_HEADING = "FAQs on OSM Electric Auto";

export const LOAN_HEADER = "OSM EV loan";

export const CTA_TEXT = "Get On Road Price";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const AVAILABLE_BRANDS_TITLE = "Available Brands";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "OSM" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "OSM",
      item: VEHICLE_LINK,
    },
  ],
};